export enum SHOW_MODE {
    ALWAYS = 'always'
}
